import { zodResolver, type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  RejectedProctorRequestEditionFormSchema,
  type RejectedProctorRequestEditionFormInput,
} from './schemas';

type RejectedProctorRequestEditionFormProviderProps = PropsWithChildren;

export default function RejectedProctorRequestEditionFormProvider(
  props: Readonly<RejectedProctorRequestEditionFormProviderProps>,
) {
  const { children } = props;

  const formContext = useForm<RejectedProctorRequestEditionFormInput>({
    resolver: zodResolver(RejectedProctorRequestEditionFormSchema),
    defaultValues: {
      personal: {
        idNumber: '',
        titleTh: null,
        firstNameTh: '',
        lastNameTh: '',
        titleEn: null,
        firstNameEn: '',
        lastNameEn: '',
        email: '',
        phoneNumber: '',
        address: '',
      },
      employeeInfo: {
        code: '',
        position: '',
        department: '',
        termination: { isAssigned: 'false', endedAt: null },
      },
      document: {
        agreementForms: [],
        identifications: [],
      },
    } as unknown as RejectedProctorRequestEditionFormInput,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
